/**
 * Kingdom Minded - product variant selection (select-based, live-site parity).
 * 2026-09-22 (final audit): whole-dollar prices drop the ".00" so the product page reads
 * "$55" exactly like the product cards ("From $55").
 */
(function () {
  function money(cents, format) {
    const amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(/\.00$/, '');
    return (format || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, amount);
  }
  function init(form) {
    const section = form.closest('.km-product');
    if (!section) return;
    const dataEl = section.querySelector('[data-km-variants]');
    if (!dataEl) return;
    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const idInput = form.querySelector('input[name="id"]');
    const addBtn = form.querySelector('.km-product__add');
    const priceNow = section.querySelector('.km-product__price-now');
    const priceWas = section.querySelector('.km-product__price-was');
    const format = dataEl.dataset.moneyFormat;
    function selected() {
      return Array.from(form.querySelectorAll('[data-km-option]')).map((s) => s.value || null);
    }
    function update() {
      const chosen = selected();
      const match = variants.find((v) => chosen.every((val, i) => val === null || v.options[i] === val));
      if (!match) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; } return; }
      if (idInput) idInput.value = match.id;
      if (priceNow) priceNow.textContent = money(match.price, format);
      if (priceWas) {
        const hasCompare = match.compare_at_price && match.compare_at_price > match.price;
        priceWas.hidden = !hasCompare;
        if (hasCompare) priceWas.textContent = money(match.compare_at_price, format);
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.dataset.label || 'Add to Cart' : 'Sold out';
      }
    }
    form.addEventListener('change', (e) => { if (e.target.matches('[data-km-option]')) update(); });
    if (addBtn && !addBtn.dataset.label) addBtn.dataset.label = addBtn.textContent.trim();
    update();
  }
  function boot() { document.querySelectorAll('.km-product__form').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => { e.target.querySelectorAll('.km-product__form').forEach(init); });
})();
